<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px">
  <div class="content container-fluid">
    <div class="bg-white page-border">
      <!--page body contant -->
      <!--header-->
      <div class="row row-replace add-m-b">
        <div class="col-md-6 col-9 col-p h5">
          <i class="fa fa-users"></i> Employee Assistance Program
        </div>
        <div class="col-md-6 col-3 top-corner-items col-p">
          <button class="btn btn-primary btn-sm" (click)="back()">
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      </div>
      <!--end header-->

      <div class="row row-replace m-t-30" *ngIf="content">
        <div class="col-12">
          <!-- <p class="h5">About MobiliseSupports Me</p> -->
          <p class="h4">
            You Are requested to call on 1800-22-7022 (Toll Free) or 02226493919
          </p>

          <p class="h5">{{ content.label }}</p>

          <p class="h5">
            <b>Link : </b>
            <a [href]="content.link" target="_blank">{{ content.link }} </a>
          </p>
          <p class="h5"><b>Login ID : </b> {{ content.login }}</p>
          <p class="h5"><b>Password : </b> {{ content.password }}</p>
          <!-- <img src="assets/img/quick/eapPoster.jpg"  class="img-fluid" > -->
          <img [src]="content.img" class="img-fluid w-100 h-100" *ngIf="content.img" />
        </div>
      </div>

      <!--end page body contant -->
    </div>
  </div>
</div>
<!-- /Page Wrapper -->
